// extracted by mini-css-extract-plugin
export default {"close":"LHLUe","closeIcon":"JheXl"};